import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ContactForm from "../components/ContactForm";

const VideoSection = ({ id, poster }) => (
  <section className="relative h-[600px] flex items-center justify-center overflow-hidden">
    <video
      autoPlay
      loop
      muted
      playsInline
      preload="metadata"
      poster={poster}
      className="absolute inset-0 w-full h-full object-cover"
    >
      <source src={`/video-${id}.webm`} type="video/webm" />
      <source src={`/video-${id}.mp4`} type="video/mp4" />
    </video>
  </section>
);

const LandingPage = () => {
  return (
    <div className="min-h-screen">
      <Header />

      {/* Hero Section with Video */}
      <section className="relative h-[600px] flex items-center justify-center overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          poster="/video-1-poster.jpg"
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src="/video-1.webm" type="video/webm" />
          <source src="/video-1.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 text-center text-white px-6">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-4 flex flex-wrap items-center justify-center gap-2 md:gap-3">
            <span className="bg-primary text-primary-foreground px-3 py-1 rounded">
              Proffsig kabelfilmning
            </span>
            <span>– utan krångel</span>
          </h1>
          <p className="text-xl mb-8">
            Realisera kreativa vinklar. Minimal setup. Maximal frihet.
            {/* Professionella resultat. Minimal setup. Maximal frihet. */}
          </p>
        </div>
      </section>

      {/* Hur det funkar */}
      <section className="py-16 px-6 bg-background">
        <div className="container mx-auto max-w-4xl text-center">
          <h2 className="text-4xl font-bold mb-8">Hur funkar det?</h2>
          <p className="text-foreground leading-relaxed">
            Kabelfilmning är en teknik där en kamera rörs längs en spänd lina
            mellan två fasta punkter, vilket möjliggör stabila och dynamiska
            kamerarörelser som annars är svåra eller omöjliga att genomföra som
            solokreatör. Vårt system bygger på en unik konstruktion som gör
            filmningen säker, stabil och mycket användarvänlig. Installation och
            användning är smidiga och helt utan krångel.
          </p>
        </div>
      </section>

      {/* Video Section 2 */}
      <VideoSection id="2" poster="/video-2-poster.jpg" />

      {/* Varför ORBIT Cable Came */}
      <section className="py-16 px-6 bg-background">
        <div className="container mx-auto max-w-4xl text-center">
          <h2 className="text-4xl font-bold mb-8">Varför ORBIT Cable Cam?</h2>
          <p className="text-foreground leading-relaxed">
            ORBIT Cable Cam ger dig cinematiska kamerarörelser utan krångel. Det
            kompakta och portabla systemet är enkelt att transportera och snabbt
            att rigga på plats. Till skillnad från traditionella kabelkameror
            krävs ingen tekniker - installation och drift kan hanteras snabbt
            och intuitivt av en person. Resultatet är professionella, dynamiska
            bilder och större kreativ frihet, samtidigt som lösningen är
            betydligt mer kostnadseffektiv än andra kabelkamerasystem. Eftersom
            systemet kan hyras utan personal behåller du full kontroll över
            produktionen - mer frihet, färre begränsningar och lägre kostnader.
          </p>
        </div>
      </section>

      {/* Svenska specialist */}
      <section className="py-2 px-6 bg-background">
        <div className="container mx-auto max-w-4xl text-center">
          <Link
            to="/how-it-works"
            className="cursor-pointer hover:opacity-80 transition-opacity inline-block"
          >
            <h2 className="text-2xl font-bold mb-8 bg-primary text-white px-4 py-3 rounded">
              Installation på under 3 minuter - se hur enkelt det är
            </h2>
          </Link>
        </div>
      </section>

      {/* Video Section 3 */}
      <VideoSection id="3" poster="/video-3-poster.jpg" />

      {/* Svenska specialist */}
      <section className="py-16 px-6 bg-background">
        <div className="container mx-auto max-w-4xl text-center">
          <h2 className="text-4xl font-bold mb-8">
            Svenska specialister på kabelfilming
          </h2>
          <p className="text-foreground leading-relaxed">
            Vi är ett svenskt företag med fokus på kabelfilmning. Med djup
            teknisk kompetens och tydligt användarfokus har vi utvecklat
            lösningar som uppfyller professionella krav inom film, TV, sport och
            digital produktion. Vår specialisering och erfarenhet gör att vi kan
            erbjuda pålitliga och genomtänkta system som levererar stabila och
            imponerande kamerarörelser.
          </p>
        </div>
      </section>

      {/* Video Section 4 */}
      <VideoSection id="4" poster="/video-4-poster.jpg" />

      {/* Contact Form */}
      <section className="py-16 px-6 bg-muted">
        <div className="container mx-auto max-w-6xl">
          <h2 className="text-4xl font-bold mb-12 text-center">Kontakta oss</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="space-y-4">
              <p className="text-foreground">
                Vill du veta mer? Vänligen fyll i kontaktformuläret eller
                kontakta oss:
              </p>
              <p className="font-semibold">
                Telefonnummer: +46 (0) 73 928 86 89
              </p>
              <p className="font-semibold">Öppettider - 9:00 - 18:00</p>
              <p className="font-semibold">Mejl: info@orbitcablecam.com</p>
            </div>
            <div>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LandingPage;
